import { transformConstants } from 'helpers/transformConstants';

const pageEventConstants = transformConstants([
  'MOKAPOS_INGREDIENT_PAGE',
  'MOKAPOS_INVENTORY_TRANSFER_START',
  'MOKAPOS_DASHBOARD_PAGE',
  'MOKAPOS_PAYMENT_CONFIGURATION_PAGE',
  'MOKAPOS_INGREDIENT_LIBRARY_PAGE',
  'MOKAPOS_REGISTRATION_START',
  'MOKAPOS_REGISTRATION_BUSINESS_INFORMATION',
  'MOKAPOS_REPORT_DISCOUNT_PAGE',
  'MOKAPOS_REPORT_COLLECTED_PAGE',
  'MOKAPOS_REPORT_CATEGORY_SALES_PAGE',
]);

export { pageEventConstants };
